import { FuelIcon, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { PARTNER } from 'constants/risk-management';
import { useCompanyData } from 'hooks/useCompanyData';
import React, { FC } from 'react';
import { brlCurrencyFormatter } from 'utils';
import { BlueStrong, StrongText, ValueText } from '../../Card/styled';
import { defaultRiskManagementValues } from '../../constants';
import { PartnerOptions } from '../../SelectPartner/types';

type ConsultationLabelsProps = {
  uniquePartnerNames: PartnerOptions[];
};

const ConsultationLabels: FC<ConsultationLabelsProps> = ({ uniquePartnerNames }) => {
  const { useGetComboFeature } = useCompanyData();
  const registerRiskManagementComboFeature = useGetComboFeature('consult-gr');

  const getRiskManagementConsultationPrice = () =>
    registerRiskManagementComboFeature?.price || defaultRiskManagementValues.consultation;

  const formatPartnerString = (partner: string): string =>
    partner.charAt(0).toUpperCase() + partner.slice(1).toLowerCase();

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        gap: 'km4',
        width: '100%',
      }}
      testId="consultation-info"
    >
      <FuelFlex defaultProps={{ justifyContent: 'flex-start', gap: 'km3', alignItems: 'center' }}>
        <FuelIcon size="small" name="risk-management" iconStyle="filled" data-testid="risk-management-approved-icon" />
        <FuelTypography weight="medium" size="body-md" color="neutral-strong" data-testid="gr-partners-approved-text">
          GR parceira usada:{' '}
          <StrongText>
            {uniquePartnerNames.length > 0 &&
              `${formatPartnerString(uniquePartnerNames[0])}${
                PARTNER[uniquePartnerNames[1]] ? ` e ${PARTNER[uniquePartnerNames[1]]}` : ''
              }`}
          </StrongText>
        </FuelTypography>
      </FuelFlex>
      <FuelFlex defaultProps={{ justifyContent: 'flex-start', gap: 'km3', alignItems: 'center' }}>
        <FuelIcon size="small" name="clock" iconStyle="filled" data-testid="clock-approved-icon" />
        <FuelTypography weight="medium" size="body-md" color="neutral-strong" data-testid="consultation-time-text">
          Re-análise de risco em <BlueStrong>5 segundos</BlueStrong>
        </FuelTypography>
      </FuelFlex>
      <FuelFlex defaultProps={{ justifyContent: 'flex-start', gap: 'km3', alignItems: 'center' }}>
        <FuelIcon size="small" name="money" iconStyle="filled" data-testid="money-approved-icon" />
        <FuelTypography
          weight="medium"
          size="body-md"
          color="neutral-strong"
          data-testid="money-consultation-value-text"
        >
          Oferta especial de <ValueText>R$ 19,90</ValueText>{' '}
          <StrongText>por {brlCurrencyFormatter(getRiskManagementConsultationPrice())}</StrongText>
        </FuelTypography>
        <FuelTag
          highlight
          label="Promoção"
          shape="rectangle"
          color="green"
          uppercase
          data-testid="promotion-consultation-tag"
        />
      </FuelFlex>
    </FuelFlex>
  );
};

export default ConsultationLabels;
